import { Directive, HostBinding, Input } from '@angular/core';

export enum AvailableStyles {
  green,
  'fill-green',
  notification,
  'notification-yellow',
}

@Directive({
  /* eslint-disable-next-line @angular-eslint/directive-selector */
  selector: 'span[UIKitBadge]',
})
export class BadgeDirective {
  @Input() styles: string[] = [];

  @HostBinding('class')
  get classes() {
    return `badge ${this.styles.map((style: string) => `badge_${style}`).join(' ')}`;
  }
  constructor() {}
}
